import GoalError from './GoalError';
class InvalidGoalPlanType extends GoalError {
    constructor(options) {
        super('The plan type is invalid', options);
    }
}
export default InvalidGoalPlanType;
